<!-- CREDIT: https://skirtles-code.github.io/vue-examples/components/tabs.html -->
<template>
  <div class="mb-4">
    <div class="flex">
      <button
        v-for="(tab, i) in tabs"
        :key="i"
        class="flex-grow text-lg mb-4"
        :class="{
          'text-left': i === 0 || tabs.length === 2,
          'text-center': tabs.length > 2 && i > 0 && i < tabs.length - 1,
          'text-right': tabs.length > 2 && i === tabs.length - 1,
        }"
        @click="activate(tab)"
      >
        <span
          class="tab-title inline-block pb-1 border-b border-[#fffef3]"
          :class="{ active: tab === active }"
        >{{ tab.title }}
        </span>
      </button>
    </div>
    <div class="body">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { computed, provide, reactive, ref } from 'vue'

const active = ref(null)
const tabs = reactive([])

const activate = tab => {
  active.value = tab
}

provide('tabs-register', tab => {
  tabs.push(tab)

  if (!active.value) {
    activate(tab)
  }

  return {
    active: computed(() => active.value === tab),

    unregister() {
      const index = tabs.indexOf(tab)
      tabs.splice(index, 1)

      if (active.value === tab) {
        activate(tabs[0])
      }
    },
  }
})
</script>

<style scoped>
.tab-title:hover,
.tab-title.active {
  @apply border-black;
}
</style>
